export default __webpack_public_path__ + "static/media/icon-3.fe1b4ab3.svg";